import React from 'react'
import { colors } from '../../styles/theme'

const SmileIcon = () => {
  const bgColor = colors.brandMidnightBlue
  const color = colors.neutralsWhite
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="24" cy="24" r="24" fill={bgColor} />
      <rect
        width="24"
        height="24"
        transform="translate(12 12)"
        fill={bgColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24 14.875C18.9604 14.875 14.875 18.9604 14.875 24C14.875 29.0396 18.9604 33.125 24 33.125C29.0396 33.125 33.125 29.0396 33.125 24C33.125 18.9604 29.0396 14.875 24 14.875ZM13.125 24C13.125 17.9939 17.9939 13.125 24 13.125C30.0061 13.125 34.875 17.9939 34.875 24C34.875 30.0061 30.0061 34.875 24 34.875C17.9939 34.875 13.125 30.0061 13.125 24Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.6977 25.4719C20.4071 25.088 19.8606 25.0108 19.475 25.3C19.0884 25.5899 19.0101 26.1384 19.3 26.525L20 26C19.3 26.525 19.2998 26.5247 19.3 26.525L19.3009 26.5262L19.3019 26.5276L19.3044 26.5309L19.3111 26.5396L19.3314 26.5656C19.348 26.5865 19.3706 26.6144 19.3991 26.6484C19.4562 26.7164 19.5373 26.809 19.6417 26.9179C19.8497 27.135 20.1541 27.4213 20.5478 27.7076C21.332 28.2779 22.5089 28.875 24 28.875C25.4911 28.875 26.668 28.2779 27.4522 27.7076C27.8459 27.4213 28.1503 27.135 28.3583 26.9179C28.4627 26.809 28.5438 26.7164 28.6009 26.6484C28.6294 26.6144 28.652 26.5865 28.6686 26.5656L28.6889 26.5396L28.6956 26.5309L28.6981 26.5276L28.6991 26.5262C28.6993 26.5259 28.7 26.525 28 26L28.7 26.525C28.9899 26.1384 28.9116 25.5899 28.525 25.3C28.1394 25.0108 27.5929 25.088 27.3023 25.4719M27.3023 25.4719L27.2965 25.4793C27.2898 25.4878 27.2778 25.5028 27.2604 25.5234C27.2257 25.5648 27.1701 25.6285 27.0948 25.7071C26.9435 25.865 26.7166 26.0787 26.4228 26.2924C25.832 26.7221 25.0089 27.125 24 27.125C22.9911 27.125 22.168 26.7221 21.5772 26.2924C21.2834 26.0787 21.0565 25.865 20.9052 25.7071C20.8299 25.6285 20.7743 25.5648 20.7396 25.5234C20.7222 25.5028 20.7102 25.4878 20.7035 25.4793L20.6977 25.4719M27.3004 25.4745L27.3014 25.4732L27.3023 25.4719"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.125 21C20.125 20.5168 20.5168 20.125 21 20.125H21.01C21.4932 20.125 21.885 20.5168 21.885 21C21.885 21.4832 21.4932 21.875 21.01 21.875H21C20.5168 21.875 20.125 21.4832 20.125 21Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.125 21C26.125 20.5168 26.5168 20.125 27 20.125H27.01C27.4932 20.125 27.885 20.5168 27.885 21C27.885 21.4832 27.4932 21.875 27.01 21.875H27C26.5168 21.875 26.125 21.4832 26.125 21Z"
        fill={color}
      />
    </svg>
  )
}
export default SmileIcon
